module.exports = __webpack_public_path__ + "img/vimcngang.51177bd7.jpg";